import AppConstatnt from '../../config/app.constants';
import USAGeoCoordinates from '../../assets/geo-json/USA.json'

class ServiceTicketsController {
    /*@ngInject*/
    constructor(Auth, $rootScope, UserBranchService, User, LocationService, RouteService, ServiceOrderService, Modal, DateUtil, Navigation, $translate, SetupService, $q, $state, UsersService, CommonLayoutService, DataCounter) {
        this.Auth = Auth;
        this.$rootScope = $rootScope;
        this.UserBranchService = UserBranchService;
        this.LocationService = LocationService;
        this.RouteService = RouteService;
        this.ServiceOrderService = ServiceOrderService;
        this.Modal = Modal;
        this.User = User;
        this.DateUtil = DateUtil;
        this.Navigation = Navigation;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.$q = $q;
        this.$state = $state;
        this.DataCounter = DataCounter;
        this.UsersService = UsersService;
        this.$rootScope.$broadcast('routeChange', '/app/service-tickets');
        this.CommonLayoutService = CommonLayoutService;

        this.model = {
            loggedInUser: User.getUser().id,
            selectedBranch: '',
            selectedLocation: '',
            selectedRoute: '',
            selectedStatus: '',
            selectedUser: '',
            selectedAction: '',
            searchKey: null,
            mapStatus: true,
            serviceOrderData: [],
            isLoadingServiceOrder: false,
            serviceHistoryData: {},
            currentBranch: User.getUser().branchId,
            branchVaultDate: '',
            dateRangeOptions: {},
            dateRangPickerOptions: {},
            dateRangPickerOptionsfor: {},
            selectedServiceZone: '',
            selectedCustomer:''
            // serviceRequestInfo: [],
            // serviceOrderInfo: []
        }

        this.acl = {};
        this.hasACL = {};

        this.totalBranches = 0;
        this.userBranchList = [];
        this.totalLocations = 0;
        this.locationList = [];
        this.totalRoutes = 0;
        this.routeList = [];
        this.totalUsers = 0;
        this.userList = [];
        this.totalStatus = 0;
        this.status = [];
        this.totalActions = 0;
        this.actions = [];
        this.totalLatLongLocations = 0;
        this.lat = 0;
        this.long = 0;
        this.centerLatitude = '';
        this.centerLongitude = '';
        this.markerPosition = [];
        this.serviceHistory = {};
        this.serviceOrderError = '';
        this.isValid = false;
        this.buckets = [];
        this.statusUpdate = {};
        this.assignTo = {};
        this.locationLatLong = [];
        this.bucketsExpand = {};
        this.sortOrderData = {};
        this.sortColumn = "encounterId";
        this.reverseSort = false;
        this.serviceZoneList = [];
        this.customerList = [];
        this.totalCustomer = 0;
        this.statusList = [
            { label: 'Complete', value: 'COMPLETE' },
            // { label: 'Invalid', value: 'INVALID' },
            { label: 'Incomplete', value: 'INCOMPLETED' },
            { label: 'Accepted', value: 'ACCEPTED' },
            { label: 'Assigned', value: 'ASSIGNED' },
            { label: 'On-Route', value: 'ON_ROUTE' },
            { label: 'On-Site', value: 'ON_SITE' },
            { label: 'Hold', value: 'HOLD' },
            { label: 'Hold-Parts', value: 'HOLD_PARTS' },
            { label: 'Cancelled', value: 'CANCELLED' },
            { label: 'Unaccepted', value: 'UNACCEPTED' },
        ];

        this.actionList = [
            { label: 'Install', value: 'install' },
            { label: 'De-Install', value: 'de-install' },
            { label: 'General', value: 'general' },
            { label: 'Connectivity-Unreachable', value: 'connectivity-unreachable' },
            { label: 'Wireless-Replace', value: 'wireless-replace' },
            { label: 'Connectivity-Poor', value: 'connectivity-poor' },
            { label: 'Dispenser', value: 'dispenser' },
            { label: 'Dispenser-Replace', value: 'dispenser-replace' },
            { label: 'Screen', value: 'screen' },
            { label: 'Paper', value: 'paper' },
            { label: 'Card-Reader', value: 'card-reader' },
            { label: 'Card-Reader-Replace', value: 'card-reader-replace' },
            { label: 'Printer', value: 'printer' },
            { label: 'Printer-Replace', value: 'printer-replace' },
            { label: 'Cassette', value: 'cassette' },
            { label: 'Keypad', value: 'keypad' },
            { label: 'Keypad-Replace', value: 'keypad-replace' },
            { label: 'Keypad-Reload-Keys', value: 'keypad-reload-keys' },
            { label: 'Lock-Battery', value: 'lock-battery' },
            { label: 'Lock-Replace', value: 'lock-replace' },
            { label: 'Upgrade-Software', value: 'upgrade-software' },
            { label: 'Mainboard-Replace', value: 'mainboard-replace' },
            { label: 'Power-Supply-Replace', value: 'power-supply-replace' },
            { label: 'Vault-Door', value: 'vault-door' },
            { label: 'Function-Keys-Replace', value: 'function-keys-replace' },
            { label: 'Cleaning', value: 'cleaning' }];

        this.toggleSwitchUI = {
            size: 'small',
            onColor: 'success',
            offColor: 'danger'
        }

        // 'red', 'darkred', 'orange', 'green', 'darkgreen', 'blue', 'purple', 'darkpurple', 'cadetblue'
        this.markerColorMapping = {
            'COMPLETE': 'green',
            'ACCEPTED': 'darkgreen',
            'ASSIGNED': 'blue',
            'UNASSIGNED': 'red',
            'ON_ROUTE': 'cadetblue',
            'ON_SITE': 'pink',
            'HOLD': 'orange',
            'CANCELLED': 'lightgray',
            // 'ASSIGNED_PENDING_CHECKOUT': 'purple',
            'CANT_COMPLETE_BUCKET': 'lightred',
            'ASSIGNED_PENDING_MESSENGER_ACCEPT': 'purple',
            'UNACCEPTED': 'darkred',
            'PENDING_ASSIGN': 'darkpurple'
        }

        this.defaultDisalbleMapButton = ['CANCELLED', 'COMPLETE', 'ASSIGNED', 'HOLD', 'ON_ROUTE'];
        this.localLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: this.$translate.instant('common.selectBranch'),  //default-label is deprecated and replaced with this.
        }
        this.dateRangeForBucket = ['CANCELLED', 'COMPLETE'];
        this.disabledResetBtn = false;
        this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
        this.isCustomer = this.User.getUser().customerUser;
        this.currentLoggedInUserInfo = this.User.getUser();
        this.externalProcessorObj = {};
        this.isCompletedIsUndo = false;
        this.canRunAutoAssignNow = this.isAutoAssignTestUser();
        this.isRunningAutoAssignNow = false;
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};
        ['service_tickets'].forEach((permissionKey) => {
            this.acl = this.User.getACL(permissionKey);

            this.hasACL = {};

            this.acl.forEach((permission) => {
                this.hasACL[permission] = true;
            });
        });
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.currentBranch),
            this.getUserBranches(),
            this.loadPermission()
        ])
            .then((data) => {
                this.branchInfo = data[0];
                this.setDefaultBranch();
                this.model.branchVaultDate = data[0].currentVaultDate; // branch vaultDate without conversion
            })
            .then(() => {
                let today = moment().startOf('day').format();
                this.dateRangeForBucket.forEach((bucket) => {
                    this.model.dateRangeOptions[bucket] = { startDate: null, endDate: null };
                    this.setDateRangeOptions(today, this.model.dateRangeOptions[bucket], 'dateRangPickerOptionsfor');
                    this.model.dateRangeOptions[bucket].startDate = moment(today).subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    this.model.dateRangeOptions[bucket].endDate = moment(today).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                })
                const obj = this.DataCounter.getData()
                if (obj) {
                  this.model.searchKey = obj.encounterId
                }
                if (this.$state.params && this.$state.params.encounterId) {
                  this.model.searchKey = this.$state.params.encounterId;
                }
                this.replaceURL();
                this.loadData();
            })
    }

    replaceURL() {
      if (this.model.searchKey) {
        this.$state.transitionTo('serviceTickets', { id: this.model.searchKey });
      }
    }

    serviceTicketSort(column, bucket) {
        if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

        if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.sortColumn]) {
            this.sortOrderData[bucket][this.reverseSort] = (this.sortOrderData[bucket][this.sortColumn] === column) ? !this.sortOrderData[bucket][this.reverseSort] : false;
        }
        else this.sortOrderData[bucket][this.reverseSort] = false;

        this.sortOrderData[bucket][this.sortColumn] = column;
    }

    bucketSort(column, bucket){
        if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

        if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.sortColumn]) {
            this.sortOrderData[bucket][this.reverseSort] = (this.sortOrderData[bucket][this.sortColumn] === column) ? !this.sortOrderData[bucket][this.reverseSort] : false;
        }
        else this.sortOrderData[bucket][this.reverseSort] = false;

        this.sortOrderData[bucket][this.sortColumn] = column;
        if(bucket === 'COMPLETE' || bucket === 'CANCELLED') {
            this.bucketPageChange(bucket)
        }
    }

    // load user branches
    getUserBranches(searchKey, offset) {
        searchKey = searchKey || '';

        return this.ServiceOrderService.getUserBranchList(this.model.loggedInUser)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalBranches = data.results.length;
                    this.userBranchList = this.userBranchMap(data.results);
                }
                else {
                    const branches = this.userBranchMap(data.results);
                    this.userBranchList = this.userBranchList.concat(branches);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    userBranchMap(branches) {
        return branches.map((branch) => {
            return {
                Key: branch.branchId,
                Value: branch.branchId,
                branchVaultDate: branch.currentVaultDate
            }
        });
    }

    resetLocations() {
        this.model.selectedLocation = '';
    }

    resetRoutes() {
        this.model.selectedRoute = '';
    }

    resetUsers() {
        this.model.selectedUser = '';
    }

    resetActions() {
        this.model.selectedAction = '';
    }

    resetServiceZones(){
        this.model.selectedServiceZone = '';
    }

    resetCustomer() {
        this.model.selectedCustomer = '';
    }

    resetDateFilter() {
        this.dateRangeForBucket.forEach((bucket) => {
            this.model.dateRangeOptions[bucket].startDate = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.model.dateRangeOptions[bucket].endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
        })
    }
    loadStatus() {
        this.totalStatus = this.statusList.length;
        const status = this.mappingStatus(this.statusList);
        this.status = this.status.concat(status);
    }


    mappingStatus(data) {
        return data.map((status) => {
            return {
                Key: status.label,
                Value: status.value
            }
        });
    }

    loadActions() {
        this.actions = [];
        // this.totalActions = this.actionList.length;
        const action = this.mappingAction(this.actionList);
        this.actions = this.actions.concat(action);
        this.totalActions = this.actions.length;
    }

    mappingAction(data) {
        return data.map((action) => {
            return {
                Key: action.label,
                Value: action.value || action.actionCodeId
            }
        });
    }

    loadMap() {
        this.centerLatitude = this.lat ? (this.lat / this.totalLatLongLocations) : 39.68649209557518;
        this.centerLongitude = this.long ? (this.long / this.totalLatLongLocations) : -101.48273981764913;

        setTimeout(() => {
            this.map = L.map('map', {});

            var osm = new L.TileLayer.BoundaryCanvas("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                boundary: USAGeoCoordinates,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            });

            this.map.addLayer(osm);
            this.map.fitBounds(this.locationLatLong.length ? this.locationLatLong : [[this.branchInfo.gpsLat, this.branchInfo.gpsLong]]);

            this.buckets.forEach((d) => {
                this.model.serviceOrderData[d.bucket].items.forEach((data) => {
                    if (data && data.lat && data.long && d.isShow) {
                        this.locationInfo = '<strong>' + data.locationName + '</strong>' + '<br>' + data.address + ' - ' + data.zip +
                            '<br>' + data.city + ', ' + data.state;

                        const id = L.marker([data.lat, data.long],
                            {
                                icon: new L.AwesomeNumberMarkers({
                                    number: data.encounterId,
                                    markerColor: this.markerColorMapping[d.bucket]
                                }),
                                zIndexOffset: d.bucket === 'COMPLETE' ? -1000 : d.bucket === 'CANCELLED' ? -2000 : 0
                            })
                            .addTo(this.map)
                            .bindPopup(this.locationInfo)

                        id.on('mouseover', function () {
                            id.openPopup();
                        });

                        id.on('mouseout', function () {
                            id.closePopup();
                        });

                    }
                })
            })
        }, 500);
    }

    reloadMap() {
        if (this.model.mapStatus) return this.loadMap();
    }

    isAutoAssignTestUser() {
        const firstName = (this.User.getUser().firstName || '').toUpperCase();
        const lastName = (this.User.getUser().lastName || '').toUpperCase();
    
        return (
            (firstName === 'COORWORKS' && lastName === 'ADMIN') ||
            (firstName === 'ADMIN' && lastName === 'COORWORKS') ||
            (firstName === 'HANK' && lastName === 'WRIGHT') || 
            (firstName === 'WRIGHT' && lastName === 'HANK') 
        );
    }

    runAutoAssignNow() {
        if (this.isRunningAutoAssignNow) return;
        this.isRunningAutoAssignNow = true;

        this.ServiceOrderService.runAutoAssignNow()
            .then(() => {
                this.Modal.alert({
                    header: 'Success',
                    message: 'Auto-assign job has been triggered.',
                    type: 'success',
                    callback: ({ modal }) => { modal.close() }
                });
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.isRunningAutoAssignNow = false;
            })
    }

    resetData() {
        this.disabledResetBtn = true;
        this.resetMultiBranchSelection();
        this.model.selectedBranch = [];
        this.model.selectedStatus = '';
        this.model.selectedUser = '';
        this.model.selectedAction = '';
        this.model.searchKey = '';
        this.totalLocations = 0;
        this.totalRoutes = 0;
        this.totalUsers = 0;
        this.totalServiceZone = 0;
        this.totalCustomer = 0;
        this.model.mapStatus = true;
        this.bucketsExpand = {};

        this.resetLocations();
        this.resetRoutes();
        this.resetUsers();
        this.resetActions();
        this.resetDateFilter();
        this.resetServiceZones();
        this.setDefaultBranch();
        this.resetCustomer();

        this.model.selectedBranch = [{
            Key: this.model.currentBranch,
            Value: this.model.currentBranch,
            branchVaultDate: this.model.branchVaultDate
        }];

        if (this.map) {
            this.map = undefined;
        }

        this.loadData();
    }

    getServiceOrders() {
        this.model.isLoadingServiceOrder = true;

        let locationId = this.model.selectedLocation ? this.model.selectedLocation.Value : null;
        let routeId = this.model.selectedRoute ? this.model.selectedRoute.Value : null;
        let userId = this.model.selectedUser ? this.model.selectedUser.Value : null;
        let actionId = this.model.selectedAction ? this.model.selectedAction.Value : null;
        let branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(branch => branch.Value) : [];
        let serviceZoneId = this.model.selectedServiceZone ? this.model.selectedServiceZone.Value : null;
        let customerId = this.model.selectedCustomer ? this.model.selectedCustomer.Value : null;
        let bucketName = '';
        let filter = {
            pageLimit: AppConstatnt.defaultPageLimit,
            pageOffset: 0,
            searchKey: this.model.searchKey ? this.model.searchKey : null,
            dateRange: {}
        };

        this.dateRangeForBucket.forEach((bucket) => {
            filter.dateRange[bucket] = { startDate: null, endDate: null };
            filter.dateRange[bucket].startDate = moment(this.model.dateRangeOptions[bucket].startDate).format('YYYY-MM-DD HH:mm:ss');
            filter.dateRange[bucket].endDate = moment(this.model.dateRangeOptions[bucket].endDate).format('YYYY-MM-DD HH:mm:ss');
            filter.dateRange[bucket].columnName = this.sortColumn;
            filter.dateRange[bucket].sortAsc = this.reverseSort;
        });

        this.buckets = [];
        this.serviceOrderError = '';
        this.locationLatLong = [];
        this.userList = [];

        return this.ServiceOrderService.getServiceOrder(branchIds, locationId, routeId, userId, actionId, bucketName, filter, moment.tz.guess(), customerId, serviceZoneId)
            .then((data) => {
                this.model.serviceOrderData = data.results;
                this.model.totalServiceOrders = data.totalRecords;
                this.totalCompletedAndCancelledServiceTickets = data.totalCompletedAndCancelledServiceTickets;
                this.actionList = data.actionCodes;
                this.browserTimezone = moment.tz.guess();
                let keys = Object.keys(this.model.serviceOrderData);
                this.setFilterData(data);
                for (let k in this.model.serviceOrderData) {
                    if(k === 'HOLD'){
                        let items = this.model.serviceOrderData[k].items;
                        items.map((item) => {
                            item.timeToHold = this.calculateDuration(item.acceptedOn, item.statusTimestamp)
                        })
                    }
                    if(k === 'ASSIGNED' || k === 'ASSIGNED_PENDING_MESSENGER_ACCEPT'){
                        let items = this.model.serviceOrderData[k].items;
                        items.map((item) => {
                            item.timeToAssigned  = this.calculateDuration(item.acceptedOn, item.firstAssignOn)
                        })
                    }
                    if(k === 'ON_ROUTE'){
                        let items = this.model.serviceOrderData[k].items;
                        items.map((item) => {
                            item.timeToOnRoute  = this.calculateDuration(item.acceptedOn, item.firstOnRouteOn)
                        })
                    }
                    if(k === 'ON_SITE'){
                        let items = this.model.serviceOrderData[k].items;
                        items.map((item) => {
                            item.timeToOnSite  = this.calculateDuration(item.acceptedOn, item.firstOnSiteOn)
                        })
                    }
                }
                setTimeout(() => {
                    keys.map((key) => {
                        if ((this.model.serviceOrderData[key] && this.model.serviceOrderData[key].items.length) || (key == 'COMPLETE' || key == 'CANCELLED')) this.buckets.push({ bucket: key });
                    });

                    this.buckets.forEach((d, i) => {
                        if (this.bucketsExpand) {
                            this.bucketsExpand[d.bucket] = {
                                isExpanded: (this.bucketsExpand[d.bucket] && this.bucketsExpand[d.bucket].isExpanded) ? this.bucketsExpand[d.bucket].isExpanded : false,
                                bucketName: d.bucket,
                                child: (this.bucketsExpand[d.bucket] && this.bucketsExpand[d.bucket].child) ? this.bucketsExpand[d.bucket].child : {},
                                // isShow: (this.bucketsExpand[d.bucket] && (typeof this.bucketsExpand[d.bucket].isShow) !== 'undefined') ? this.bucketsExpand[d.bucket].isShow : this.defaultDisalbleMapButton.indexOf(d.bucket) >= 0 ? false : true
                                isShow: (this.bucketsExpand[d.bucket] && (typeof this.bucketsExpand[d.bucket].isShow) !== 'undefined') ? this.bucketsExpand[d.bucket].isShow: (d.bucket === 'CANCELLED' || d.bucket === 'COMPLETE' ? false : true)
                            }
                            d.bucketExpanded = this.bucketsExpand[d.bucket].isExpanded || false;
                        }

                        this.model.serviceOrderData[d.bucket].page = this.model.serviceOrderData[d.bucket].page || 1;
                        this.model.serviceOrderData[d.bucket].pageLimit = this.model.serviceOrderData[d.bucket].pageLimit || AppConstatnt.defaultPageLimit;
                        this.model.serviceOrderData[d.bucket].pageOffset = this.model.serviceOrderData[d.bucket].pageOffset || 0;

                        if (this.model.serviceOrderData[d.bucket] && this.model.serviceOrderData[d.bucket].items.length) {
                            this.isValid = true;
                            this.model.serviceOrderData[d.bucket].items.forEach((info, index) => {
                                this.decorateServiceTicket(info);
                                if (info.lat && info.long) {
                                    this.locationLatLong.push(new Array(info.lat, info.long));
                                    this.totalLatLongLocations += 1; // locations which have lat, long value counted as totalLatLongLocations
                                    this.lat += info.lat; // sum of Lattitude value of location
                                    this.long += info.long; //  sum of Longitude value of location
                                }
                                this.model.serviceOrderData[d.bucket].items[index].expanded = this.bucketsExpand[d.bucket].child[info.encounterId] || false;
                            })
                        }

                        this.bucketItem = this.model.serviceOrderData[d.bucket].items;
                        this.serviceTicketSort(this.sortColumn, d.bucket);
                    });

                    if (!this.buckets.length || !data.locations.length || !data.routes.length) this.isValid = false;
                    else if (this.buckets.length || data.locations.length || data.routes.length) this.isValid = true;

                    this.validateMap();
                    this.calculateThresholds();
                    this.getLastUpdatedTime();

                    if (this.model.mapStatus && this.isValid) { this.loadMap(); }
                    this.model.isLoadingServiceOrder = false;
                }, 1);
            })
            .catch((err) => {
                console.log(err);
                this.model.isLoadingServiceOrder = false;
                this.serviceOrderError = err.data.message;
            })
    }

    loadOrderHistoryData(data, event) {
        if (data.expanded) {
            this.getServiceOrderHistory(data, event)
        }
        else {
            delete this.model.serviceHistoryData[data.serviceOrderId];
        }
        // window.onscroll = function () { window.scrollBy(0, 0); };
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        document.getElementById(`expand-btn-${data.serviceOrderId}`).blur();
    }

    getServiceOrderHistory(data, event) {
        this.serviceHistory[data.serviceOrderId] = { process: true };
        return this.ServiceOrderService.serviceOrderHistory(data.encounterId, data.serviceOrderId, data.externalProcessorId)
            .then((history) => {
                this.model.serviceHistoryData[data.serviceOrderId] = { details: history };
                if (!data.externalProcessorId) {
                    let result = [...this.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory,
                    ...this.model.serviceHistoryData[data.serviceOrderId].details.supervisorUpdateLogs];

                    this.updateHistory = this.sortData(result);
                    this.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory = this.mergeUpdateHistory(this.updateHistory);
                }
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.serviceHistory[data.serviceOrderId].process = false;
            })
        if (event) event.preventDefault();
    }

    openUpdateServiceHistory(updateHistory, serviceOrder) {
        if (!updateHistory || !updateHistory.length) return;
        const firstItem = updateHistory[0];
        let shouldRefreshMainList = false;
        let refParams = {};
        if (serviceOrder) {
            refParams = {
                serviceOrderId: serviceOrder.serviceOrderId,
                encounterId: serviceOrder.encounterId,
                externalProcessorId: serviceOrder.externalProcessorId
            };
        } else {
            refParams = {
                serviceOrderId: firstItem.serviceOrderId,
                encounterId: firstItem.encounterId || (firstItem.entryData && firstItem.entryData.encounterId),
                externalProcessorId: firstItem.externalProcessorId
            };
        }

        this.Modal.updateServiceHistory(updateHistory, ({ modal, history, isSingleAction, onSuccess, $scope }) => {
            $scope.model.isLoading = true;
            if (!history || !history.length) {
                if (!isSingleAction) modal.close();
                return;
            }

            this.ServiceOrderService.updateServiceHistory(history, this.browserTimezone, this.model.currentBranch)
                .then((res) => {
                    if (onSuccess) onSuccess(res.results);
                    if (isSingleAction) {
                        const item = history[0];
                        const isDeleted = item && item.isDeletedFlag;
                        if (isDeleted || (item && (item.isFirstAccepted || item.isLastCompleted))) shouldRefreshMainList = true;

                        this.Modal.alert({
                            header: 'Success',
                            message: isDeleted ? 'Status deleted successfully' : 'Status updated successfully',
                            type: 'success',
                            callback: ({ modal: alertModal }) => { alertModal.close() }
                        });
                        // this.getServiceOrderHistory(refParams);
                    }
                    if (!isSingleAction) {
                        modal.close();
                        if (history.some(item => item.isDeletedFlag || item.isFirstAccepted || item.isLastCompleted)) {
                            shouldRefreshMainList = true;
                        }
                        this.getServiceOrderHistory(refParams);
                        if (shouldRefreshMainList) {
                            this.getServiceOrders();
                        }
                    }
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                }).finally(() => {
                    $scope.model.isLoading = false;
                });
        }, ({ modal }) => {
            if (modal) modal.close();
            this.getServiceOrderHistory(refParams);
            if (shouldRefreshMainList) {
                this.getServiceOrders();
            }
        });
    }

    mergeUpdateHistory(updateHistory) {
        // 'service-tickets-assign-to-user'
        this.isCompletedIsUndo = false;
        const statusCodeList = ['ACCEPTED', 'ASSIGNED', 'ON_ROUTE', 'ON_SITE', 'HOLD', 'HOLD_PARTS', 'INCOMPLETED', 'COMPLETE', 'CANCELLED'];
        const statusLogMapping = {
            'ACCEPTED': ['create-service-order'],
            'ASSIGNED': ['service-tickets-assign-to-route', 'send-assign-notification'],
            'ON_ROUTE': ['service-ticket-on-route'],
            'ON_SITE': ['service-ticket-on-site'],
            'HOLD': ['service-ticket-hold', 'service-ticket-hold-parts'],
            'HOLD_PARTS': ['service-ticket-hold-parts'],
            'COMPLETE': ['service-ticket-completed', 'mark-service-order-completed', 'service-ticket-undo-completed'],
            'CANCELLED': ['service-ticket-cancelled', 'service-ticket-undo-cancelled'],
            'INCOMPLETED': ['service-ticket-incomplete']
        };
        const finalResults = [];

        for (let index = 0; index < updateHistory.length; index++) {
            const history = updateHistory[index]
            if (statusCodeList.includes(history.status)) {
                const matchingLogIndex = _.findIndex(updateHistory, (record, i) => {
                    const match = i > index && record.entryType && statusLogMapping[history.status] && statusLogMapping[history.status].includes(record.entryType);
                    return match;
                });

                if (matchingLogIndex !== -1) {
                    const logRecord = updateHistory[matchingLogIndex];
                    logRecord.statusUpdate = this.getBucketName(history.status).concat(' ((', this.translateEntryType(logRecord.entryType), ')').split(' (');

                    const merged = { ...logRecord, ...history };
                    merged.logId = logRecord.id;
                    if (merged.entryData && merged.serviceOrderStatusNote) {
                        merged.entryData.note = merged.serviceOrderStatusNote;
                    }
                    finalResults.push(merged);
                    updateHistory.splice(matchingLogIndex, 1);
                }
                else {
                    const lastResult = finalResults[finalResults.length - 1];
                    if (lastResult && lastResult.entryType && statusLogMapping[history.status] && statusLogMapping[history.status].includes(lastResult.entryType)) {
                        const merged = { ...lastResult, ...history };
                        merged.logId = lastResult.id;
                        merged.statusUpdate = this.getBucketName(history.status).concat(' ((', this.translateEntryType(lastResult.entryType), ')').split(' (');
                        if (merged.entryData && merged.serviceOrderStatusNote) {
                            merged.entryData.note = merged.serviceOrderStatusNote;
                        }
                        finalResults[finalResults.length - 1] = merged;
                    } else {
                        finalResults.push(history);
                    }
                }
            }
            else {
                finalResults.push(history);
            }
        }

        const userIndex = _.findIndex(finalResults, { entryType: 'service-tickets-assign-to-user' });
        if (userIndex !== -1) {
            const assignedIndex = _.findIndex(finalResults, { status: 'ASSIGNED', timestamp: finalResults[userIndex].timestamp });
            if (assignedIndex !== -1) {
                const [userItem] = finalResults.splice(userIndex, 1);
                const newIndex = userIndex < assignedIndex ? assignedIndex : assignedIndex + 1;
                finalResults.splice(newIndex, 0, userItem);
            }
        }

        const editableStatuses = ['ACCEPTED', 'ASSIGNED', 'ON_ROUTE', 'ON_SITE', 'COMPLETE'];
        editableStatuses.forEach((status) => {
            const lastStatus = _.findLast(finalResults, { status: status });
            if (lastStatus) lastStatus.isLatest = true;
        })

        const lastOnSite = _.findLast(finalResults, { status: 'ON_SITE' });
        const lastComplete = _.findLast(finalResults, { status: 'COMPLETE' });
        if (lastOnSite) lastOnSite.isLatest = true;
        const lastOnSiteIndex = lastOnSite ? finalResults.indexOf(lastOnSite) : -1;
        const lastCompleteIndex = lastComplete ? finalResults.indexOf(lastComplete) : -1;

        if (lastComplete && lastCompleteIndex > lastOnSiteIndex) {
            lastComplete.isLatest = true;
        } else {
            this.isCompletedIsUndo = true;
        }
        
        const firstAccepted = _.find(finalResults, { status: 'ACCEPTED' });
        if (firstAccepted) firstAccepted.isFirstAccepted = true;

        return finalResults;
    }

    sortData(data) {
        return data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp) ||
            ((b.entryType || '').includes('undo') - (a.entryType || '').includes('undo')));
    }

    checkBrowserDiff(date) {
        let
            browserTimezone = moment.tz.guess(),
            startTime = moment.tz(date, browserTimezone).format(),
            currentTime = moment().format();
        return moment(currentTime).diff(startTime);
    }

    convertToMillisecond(date) {
        var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
        var convertDate = moment.tz(date, browserTimezone).format();  // convert date to specific timezone
        return moment(convertDate).valueOf(); // convert date in milliseconds
    }

    uniqueLocations() {
        let data = [];
        this.locationList = [];
        this.buckets.forEach((d) => {
            if (this.model.serviceOrderData[d.bucket].items && this.model.serviceOrderData[d.bucket].items.length) data.push(...this.model.serviceOrderData[d.bucket].items)
        })
        const locationGroup = _.groupBy(data, 'locationId');
        const keys = Object.keys(locationGroup);
        keys.map((key) => {
            let location = key.concat(" | ", locationGroup[key][0].locationName);
            this.locationList.push({ Key: location, Value: key })
        })
        this.totalLocations = this.locationList.length;
    }

    uniqueRoutes() {
        let data = [];
        this.routeList = [];
        this.buckets.forEach((d) => {
            if (this.model.serviceOrderData[d.bucket] && this.model.serviceOrderData[d.bucket].items.length) data.push(...this.model.serviceOrderData[d.bucket].items)
        })
        const routeGroup = _.groupBy(data, 'routeId');
        const keys = Object.keys(routeGroup);
        keys.map((key) => {
            let route = key.concat(" | ", routeGroup[key][0].routeName);
            this.routeList.push({ Key: route, Value: key })
        })
        this.totalRoutes = this.routeList.length;
    }

    uniqueUsers() {
        let bucketKeys = Object.keys(this.model.serviceOrderData);
        let users = [];
        if (bucketKeys && bucketKeys.length) {
            bucketKeys.map(key => {
                if (this.model.serviceOrderData[key] && this.model.serviceOrderData[key].items.length) {
                    this.model.serviceOrderData[key].items.map((order, j) => {
                        if (order.statusCode == 'ASSIGNED' && order.userId && order.username) {
                            users.push({
                                Key: order.userId + " | " + order.username,
                                Value: order.userId
                            })
                        }
                    })
                }
            })
        }
        this.userList = _.orderBy(_.uniqBy(users, 'Value'));
        this.totalUsers = this.userList.length;
    }
    
    loadData() {
        setTimeout(() => {
            this.getServiceOrders()
                .then(() => {
                    this.disabledResetBtn = false;
                    this.loadActions();
                })
                .then(() => {
                    this.DataCounter.setData();
                })
        })
    }

    validateMap() {
        this.buckets.map((data) => {
            if (this.model.mapStatus && this.model.serviceOrderData[data.bucket] && this.model.serviceOrderData[data.bucket].items.length) {
                return data.isShow = this.model.mapStatus ? this.bucketsExpand[data.bucket] && typeof this.bucketsExpand[data.bucket].isShow != 'undefined' ? this.bucketsExpand[data.bucket].isShow : true : false;
            }
            if (!this.model.mapStatus && this.model.serviceOrderData[data.bucket] && this.model.serviceOrderData[data.bucket].items.length) {
                return data.isShow = this.model.mapStatus ? this.bucketsExpand[data.bucket] && typeof this.bucketsExpand[data.bucket].isShow != 'undefined' ? this.bucketsExpand[data.bucket].isShow : false : false;
            }
        })
    }

    validateMarkers(data) {
        if (this.map) {
            this.map.remove();
            this.map = undefined;
            this.loadMap();
        }
    }

    details(data) {
        this.Modal.serviceOrderDetail(data, ({ modal }) => { }, ({ modal }) => {
            modal.close();
        })
    }

    redirectToServiceHistory(locationId) {
        this.Navigation.goToServiceHistory(locationId, null, true, null);
    }

    goToServiceHistory(serviceOrder) {
        if (this.model.currentBranch === serviceOrder.branchId) {
            this.redirectToServiceHistory(serviceOrder.locationId);
        }
        else {
            this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId)
                .then(() => {
                    this.redirectToServiceHistory(serviceOrder.locationId);
                })
        }
    }

    // Update Service Order Note
    serviceOrderNotes(data, bucket, event) {
        const vaultDate = this.formatVaultDate(data.branchCurrentVaultDate);
        const openNotesModal = () => {
            const updatedHistory = this.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory;
            this.Modal.serviceOrderNotes(data, updatedHistory, ({ modal, serviceOrderUserNote, serviceOrderNote, serviceOrderUserNotes, $scope }) => {
                $scope.model.loading = true;
                this.ServiceOrderService.updateServiceOrderNoteList(data.encounterId, data.serviceOrderId, data.branchId, serviceOrderNote, vaultDate, data.routeId, data.statusCode, serviceOrderUserNotes)
                    .then(() => {
                        modal.close();
                        let serviceOrder = _.find(this.model.serviceOrderData[bucket].items, { 'encounterId': data.encounterId });
                        serviceOrder.serviceOrderUserNote = serviceOrderUserNote;
                        serviceOrder.serviceOrderNote = serviceOrderNote;
                        if (serviceOrderUserNotes && serviceOrderUserNotes.length) {
                            serviceOrderUserNotes.forEach(note => {
                                let history = _.find(updatedHistory, { id: note.id });
                                if (history) {
                                    history.serviceOrderStatusNote = note.note;
                                }
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        $scope.model.loading = false;
                    })
            })
        };

        if (this.model.serviceHistoryData[data.serviceOrderId] &&
            this.model.serviceHistoryData[data.serviceOrderId].details &&
            this.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory &&
            (!this.serviceHistory[data.serviceOrderId] || !this.serviceHistory[data.serviceOrderId].process)) {
            openNotesModal();
        } else {
            this.getServiceOrderHistory(data, event).then(() => {
                openNotesModal();
            })
        }
    }

    getBucketName(status) {
        switch (status) {
            case 'INCOMPLETED':
                return this.$translate.instant('serviceTickets.incomplete');
            case status:
                return this.$translate.instant('serviceTickets.status_' + status);
            default: return;
        }
    }

    // Auto Close (Service Actions) table when bucket is closed
    autoCloseTable(data) {
        if (this.model.serviceOrderData[data.bucket] && this.model.serviceOrderData[data.bucket].items && this.model.serviceOrderData[data.bucket].items.length) {
            this.model.serviceOrderData[data.bucket].items.forEach((serviceOrder) => {
                if (!data.bucketExpanded) {
                    if (serviceOrder.expanded) {
                        serviceOrder.expanded = false;
                    }
                }
            })
        }
    }

    // Update service order status
    serviceOrderStatusUpdateModal(serviceOrder) {
        if (this.statusUpdate[serviceOrder.encounterId] && this.statusUpdate[serviceOrder.encounterId].process) return;
        this.statusUpdate[serviceOrder.encounterId] = { process: true };

        this.UsersService.checkSupervisor(this.model.loggedInUser)
            .then((userInfo) => {
                this.Modal.serviceOrderStatusUpdate(serviceOrder, this.isCustomer ? false : !userInfo.supervisor, this.customerId, this.currentLoggedInUserInfo, ({ modal, note, status, supervisorId }) => {
                    let supId = userInfo.supervisor ? userInfo.id : supervisorId;
                    // if selected status is `ASSIGNED` then call assign modal so branch operator can assign `route` or `user` to service tickets
                    if (status === 'ASSIGNED') {
                        return this.serviceOrderAssignModal(serviceOrder, note).then(() => {
                            modal.close();
                            this.statusUpdate[serviceOrder.encounterId].process = false;
                        });
                    }
                    else if (status === 'COMPLETE') {
                        this.ServiceOrderService.getLastArrivalTime(serviceOrder.serviceOrderId)
                            .then((data) => {
                                serviceOrder.lastArrivalTime = data.lastArrivalTime || null;
                                return this.serviceOrderActionsModal(serviceOrder, note, supId).then(() => {
                                    modal.close();
                                    this.statusUpdate[serviceOrder.encounterId].process = false;
                                })
                            }).catch(() => {
                                console.log(err);
                                this.Modal.errorModal(err.data.message);
                            })
                    }
                    else {
                        return this.updateServiceOrderStatus(serviceOrder, status, supId, note, modal);
                    }
                }, ({ modal }) => {
                    if (modal) modal.close();
                    this.statusUpdate[serviceOrder.encounterId].process = false;
                })
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    updateServiceOrderStatus(serviceOrder, status, supervisorId, note, modal) {
        const vaultDate = this.formatVaultDate(serviceOrder.branchCurrentVaultDate);

        return this.ServiceOrderService.updateServiceOrderStatus(serviceOrder.routeId, status, serviceOrder.encounterId, supervisorId, note,
            serviceOrder.branchId, serviceOrder.serviceOrderId, vaultDate)
            .then(() => {
                this.loadData(); // refresh data after status update
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        this.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    }
                    else {
                        this.Modal.errorModal(err.data.message);
                    }
                }
            })
            .finally(() => {
                if (modal) modal.close();
                this.statusUpdate[serviceOrder.encounterId].process = false;
            })
    }

    // assign service tickets to route or user or externalProcessor
    serviceOrderAssignModal(serviceOrder, note = null) {
        const encounterId = serviceOrder.encounterId;

        if (this.assignTo[encounterId] && this.assignTo[encounterId].process) return;
        this.assignTo[encounterId] = { process: true };

        const defer = this.$q.defer();
        const vaultDate = this.formatVaultDate(serviceOrder.branchCurrentVaultDate);

        this.ServiceOrderService.validateServiceOrderAssign(serviceOrder.serviceOrderId)
            .then(() => {
                return this.Modal.serviceOrderAssign(serviceOrder, vaultDate, ({ modal, routeId, userId, externalProcessorCode, currentStats }) => {
                    let route = currentStats === 'route' ? routeId : null; // pass routeId if service tickets assign to route (for this case pass userId as null)
                    let user = currentStats === 'user' ? userId.toString() : null; // pass userId if service tickets assign to user (for this case pass routeId as null)
                    if (externalProcessorCode) {
                        this.ServiceOrderService.transferUnassignedToExternal(encounterId, externalProcessorCode, serviceOrder.branchId, this.model.loggedInUser)
                            .then(() => {
                                this.loadData();
                            })
                            .catch((err) => {
                                console.log(err);
                                this.Modal.errorModal(err.data.message);
                            })
                    }
                    else {
                        return this.assignToRouteOrUserByEncounterId(serviceOrder.serviceOrderId, encounterId, user, route, note, serviceOrder.branchId, vaultDate, serviceOrder.userId)
                            .then(() => defer.resolve())
                    }
                }, ({ modal }) => {
                    if (modal) modal.close();
                })
            })
            .catch((err) => {
                defer.reject();
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.assignTo[encounterId].process = false;
            })

        return defer.promise;
    }

    assignToRouteOrUserByEncounterId(serviceOrderId, encounterId, user, route, note, branchId, branchVaultDate, serviceTicketUserId) {
        return this.ServiceOrderService.assignToRouteOrUser(serviceOrderId, encounterId, user, route, note, branchId, branchVaultDate, serviceTicketUserId)
            .then(() => {
                this.loadData();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        this.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    }
                    else {
                        this.Modal.errorModal(err.data.message);
                    }
                }
            })
            .finally(() => {
                // modal.close();
                this.assignTo[encounterId].process = false;
            })
    }

    goToRouteTab(serviceOrder) {
        if (this.model.currentBranch === serviceOrder.branchId) {
            this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
        }
        else {
            this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId)
                .then(() => {
                    this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
                })
        }
    }

    redirectToRouteTab(routeId, branchVaultDate) {
        return this.Navigation.goToRouteTab(routeId, branchVaultDate, true, null);
    }

    goToUserTab(order) {
        this.Navigation.goToUserTab(order.userId);
    }

    shiftBranch(userId, selectedBranch) {
        var obj = {
            id: userId,
            branchId: selectedBranch
        };
        const defer = this.$q.defer();
        this.UsersService.updateUserBranch(obj.id, obj)
            .then((data) => {
                this.User.setUser(data);
                defer.resolve();
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
                this.Modal.errorModal(this.errorMessage);
            });
        return defer.promise;
    }

    // calculate hours, minutes, seconds between two date
    calculateDuration(startDate, endDate) {
        let start = moment(startDate).valueOf();
        let end = moment(endDate).valueOf();

        if (start && end && end < start) { // reverse the date order
            const t = startDate;
            startDate = endDate;
            endDate = t;
        }

        let ms = moment(endDate).diff(startDate);
        let duration = moment.duration(ms);
        return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
    }

    // branchCurrentVaultDate() {
    //     return this.model.selectedBranch ? this.DateUtil.getUTCDate(this.model.selectedBranch.branchVaultDate) : null;
    // }

    formatVaultDate(branchVaultDate) {
        return this.DateUtil.getUTCDate(branchVaultDate);
    }

    translateEntryType(type) {
        return this.$translate.instant('entry_type.' + type);
    }

    undoServiceOrder(data) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;

        let title, message, status;
        if (data.statusCode === 'COMPLETE' || data.completed) {
            title = this.$translate.instant('serviceTickets.undo_completed_title');
            message = this.$translate.instant('serviceTickets.undo_completed_message');
            status = 'COMPLETE'
        }
        if (data.statusCode === 'CANCELLED' || data.cancelled) {
            title = this.$translate.instant('serviceTickets.undo_cancelled_title');
            message = this.$translate.instant('serviceTickets.undo_cancelled_message');
            status = 'CANCELLED'
        }

        this.Modal.confirm({
            header: title,
            message: message + ` <strong>${data.serviceOrderId}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                this.ServiceOrderService.undoServiceOrder(status, data.encounterId, data.serviceOrderId, data.branchId, data.routeId)
                    .then(() => {
                        this.loadData();
                    })
                    .catch((err) => {
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        modal.close();
                        this.allowOnlyOnce = false;
                    })
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    formatJsonObj(obj) {
        const { status, note, ...rest } = obj;
        const orderedObj = {};
        if (status) orderedObj.status = status;
        if (note) orderedObj.note = note;
        Object.assign(orderedObj, rest);

        delete orderedObj.notes;
        delete orderedObj.serviceOrderStatusNote;
        delete orderedObj.serviceOrderStatusNotes;

        let details = JSON.stringify(orderedObj);
        let addPipe = details.replace(/,/g, ' | ');
        let removeCurlyBraces = addPipe.replace(/[{}]/g, "");
        let finalObj = removeCurlyBraces.replace(/:/g, ": ");
        return finalObj.replace(/\"/g, "");
    }

    getUpdateNoteHistory(data) {
        const { serviceOrderStatusNotes, ...rest } = data || {};
        return {
            info: this.formatJsonObj(rest),
            notes: serviceOrderStatusNotes || []
        };
    }

    // Reset Multi-Branch selection
    resetMultiBranchSelection() {
        if (this.model.selectedBranch && this.model.selectedBranch.length) {
            this.model.selectedBranch.forEach((selectedBranch) => {
                this.userBranchList.filter((branch) => {
                    if (branch.branchId == selectedBranch.branchId) {
                        branch.ticked = false;
                    }
                })
            })
        }
    }

    serviceOrderActionsModal(serviceOrder, serviceOrderStatusNote, userId) {
        const defer = this.$q.defer();

        this.Modal.serviceOrderActions(serviceOrder, ({ modal, actionCodeData, $scope, completedByUserId, completedDate, completedTime, arrivedDate, arrivedTime }) => {
            const completedDateTime = completedDate.concat(' ', completedTime);
            const completedAt = moment(completedDateTime).utc().format();
            const arrivedDateTime = arrivedDate.concat(' ', arrivedTime);
            const arrivedAt = moment(arrivedDateTime).utc().format();

            this.ServiceOrderService.markServiceOrderCompleted(actionCodeData, serviceOrder.branchId, serviceOrder.routeId, serviceOrder.serviceOrderId,
                                                               serviceOrder.encounterId, serviceOrderStatusNote, userId, completedByUserId, completedAt, arrivedAt)
                .then(() => {
                    this.loadData(); // refresh data after status update
                    modal.close();
                    defer.resolve();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        // if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_NULL_COMPLETEDBYUSERID') {
                        //     $scope.model.errorMessage = this.$translate.instant('serviceTickets.null_completed_by_userId');
                        //     this.getBranchServiceUser(serviceOrder.branchId, $scope)
                        // }
                        if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SOA_TOO_FEW_RESPONSES') {
                            $scope.model.errorMessage = this.$translate.instant('serviceTickets.too_few_responses');
                        }
                        else {
                            $scope.model.errorMessage = err.data.message;
                        }
                    }
                })
                .finally(() => {
                    $scope.model.isUpdate = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
        return defer.promise;
    }

    calculateAssignAndAcceptTime(assignTime, acceptTime) {
        return moment(assignTime).isSameOrAfter(acceptTime);
    }
    showChildBucket(val, bucketName, bucketIndex, orders) {
        // this.model.serviceOrderData[bucketName][orders.encounterId].expanded = val;
        this.bucketsExpand[bucketName].child[orders.encounterId] = val;
    }

    setStatusExpanded(bucketName) {
        this.bucketsExpand[bucketName].isExpanded = !this.bucketsExpand[bucketName].isExpanded;
    }

    refresh() {
        this.getServiceOrders()
    }

    bucketPageChange(bucketName) {
        if (!this.sortOrderData[bucketName]) this.sortOrderData[bucketName] = {};
        this.model.serviceOrderData[bucketName].process = true;
        let locationId = this.model.selectedLocation ? this.model.selectedLocation.Value : null;
        let routeId = this.model.selectedRoute ? this.model.selectedRoute.Value : null;
        // let status = this.model.selectedStatus ? this.model.selectedStatus.Value : null;
        let userId = this.model.selectedUser ? this.model.selectedUser.Value : null;
        let actionId = this.model.selectedAction ? this.model.selectedAction.Value : null;
        let branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(branch => branch.Value) : [];
        let serviceZoneId = this.model.selectedServiceZone ? this.model.selectedServiceZone.Value : null;
        let customerId = this.model.selectedCustomer ? this.model.selectedCustomer.Value : null;
        let filter = {
            searchKey: this.model.searchKey ? this.model.searchKey : null,
            pageLimit: this.model.serviceOrderData[bucketName].pageLimit || AppConstatnt.defaultPageLimit,
            pageOffset: (this.model.serviceOrderData[bucketName].page - 1) ?
                (this.model.serviceOrderData[bucketName].page - 1) * this.model.serviceOrderData[bucketName].pageLimit : 0,
            dateRange: {}
        }
        filter.dateRange[bucketName] = { startDate: null, endDate: null };
        filter.dateRange[bucketName].startDate = moment(this.model.dateRangeOptions[bucketName].startDate).format('YYYY-MM-DD HH:mm:ss');
        filter.dateRange[bucketName].endDate = moment(this.model.dateRangeOptions[bucketName].endDate).format('YYYY-MM-DD HH:mm:ss');
        filter.dateRange[bucketName].columnName = this.sortOrderData[bucketName][this.sortColumn];
        filter.dateRange[bucketName].sortAsc = this.sortOrderData[bucketName][this.reverseSort];

        this.serviceOrderError = '';
        return this.ServiceOrderService.getServiceOrder(branchIds, locationId, routeId, userId, actionId, bucketName, filter, moment.tz.guess(), customerId, serviceZoneId)
            .then((data) => {
                if (data['COMPLETE'] && data['COMPLETE'].users) {
                    this.userList = _.orderBy(_.uniqBy([...this.userList, ...data['COMPLETE'].users], 'Value'));
                }
                this.totalUsers = this.userList.length;
                this.model.serviceOrderData[bucketName].items = data[bucketName].items || [];
                this.model.serviceOrderData[bucketName].totalCount = data[bucketName].totalCount || 0
                if (this.model.serviceOrderData[bucketName] && this.model.serviceOrderData[bucketName].items.length) {
                    this.isValid = true;
                    this.model.serviceOrderData[bucketName].items.forEach((info, index) => {
                        this.decorateServiceTicket(info);

                        if (info.lat && info.long) {
                            this.locationLatLong.push(new Array(info.lat, info.long));
                            this.totalLatLongLocations += 1; // locations which have lat, long value counted as totalLatLongLocations
                            this.lat += info.lat; // sum of Lattitude value of location
                            this.long += info.long; //  sum of Longitude value of location
                        }
                        this.model.serviceOrderData[bucketName].items[index].expanded = this.bucketsExpand[bucketName].child[info.encounterId] || false;
                    });
                }
                //  else {
                // this.showBuckets();
                // }
                if (this.buckets.length <= 0) this.isValid = false;
            })
            .then(() => {
                if (this.model.mapStatus && this.isValid) this.validateMarkers();
                this.getLastUpdatedTime();
            })
            .catch((err) => {
                console.log(err);
                // this.serviceOrderError = this.$translate.instant('error.' + err.data.message);
                this.serviceOrderError = err.data.message;
            })
            .finally(() => {
                this.model.serviceOrderData[bucketName].process = false;
            })
    }

    showBuckets() {
        let bucketItems = this.buckets.filter(key => this.model.serviceOrderData[key.bucket] && this.model.serviceOrderData[key.bucket].items && this.model.serviceOrderData[key.bucket].items.length)
        this.isValid = !!bucketItems.length;
        if (!bucketItems.length) {
            this.buckets = []
        }
        return !!bucketItems.length;
    }

    getBranchServiceUser(branchId, $scope) {
        this.ServiceOrderService.getServiceUser(branchId)
            .then((data) => {
                $scope.model.serviceUserList = data.results;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
    }

    setDateRangeOptions(date, dateRangeOption, modelVal) {
        this.model[modelVal] = {
            autoApply: true,
            //   minDate: moment().subtract(14, 'days').startOf('day').format('YYYY-MM-DD'),
            opens: "left",
            drops: "auto",
            cancelOnOutsideClick: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.model.serviceOrderData[this.selectedBucket].page = 1
                    this.bucketPageChange(this.selectedBucket);
                },
                // 'show.daterangepicker': (ev, picker) => {
                //     console.log(picker, ev)
                //     // ev.opts.drops =  this.model.mapStatus ? 'up' : 'auto';
                //     // return ev
                // },
            },
            ranges: {
                'Last 2 Days': [
                    moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
            }
        }
    }

    getSelectedBucket(bucket) {
        this.selectedBucket = bucket;
        return this.selectedBucket;
    }

    setFilterData(data) {
        if (!this.totalLocations) {
            this.locationList = data.locations || [];
            this.updatedLocationList = data.locations;
            this.totalLocations = this.locationList.length;
        }

        if (!this.totalRoutes) {
            this.routeList = data.routes || [];
            this.totalRoutes = this.routeList.length;
        }

        // if (!this.totalUsers) {
        this.userList = data.users;
        this.totalUsers = this.userList.length;
        // }

        if (!this.totalServiceZone) {
            this.serviceZoneList = data.serviceZone || [];
            this.totalServiceZone = this.serviceZoneList.length;
        }

        if (!this.totalCustomer) {
            this.customerList = data.customer || [];
            this.updatedcustomerList = data.customer;
            this.totalCustomer = this.customerList.length;
            if (this.totalCustomer === 1 && !this.model.selectedCustomer && this.customerId) {
                this.model.selectedCustomer = this.customerList[0];
            }
        }
    }

    onBranchChange() {
        this.totalLocations = 0;
        this.totalRoutes = 0;
        this.totalUsers = 0;
        this.totalServiceZone = 0;
        this.totalCustomer = 0;
        this.model.searchKey = null;
        this.resetLocations();
        this.resetRoutes();
        this.resetUsers();
        this.resetActions();
        this.resetServiceZones();
        this.resetDateFilter();
        this.resetCustomer();
    }

    showBucketSearch() {
        return ((this.model.selectedBranch ||
            this.model.selectedLocation ||
            this.model.selectedRoute ||
            this.model.selectedStatus ||
            this.model.selectedUser ||
            this.model.selectedAction ||
            this.model.selectedServiceZone ||
            this.model.selectedCustomer) &&
           true);
    }

    // Calculate NOW() - (service order createdAt) time in milliseconds
    calculateHours(date) {
        let startDate = new Date();
        let endDate = new Date(date);
        let diff = moment(startDate).diff(endDate);
        return diff;
    }

    getTime(time) {
        let ms = moment.duration(time).valueOf();
        return ms;
    }

    getPriorityDurationHours(requestedTimeframe) {
        const priorityHours = {
            '24HR': 24,
            '48HR': 48,
            '72HR': 72
        };

        return priorityHours[requestedTimeframe] || null;
    }

    getPriorityReferenceTime(serviceTicket) {
        return serviceTicket.createdAt ;
    }

    formatPriorityRemaining(ms, overdueLabel = 'Overdue') {
        const absoluteMs = Math.abs(ms);
        const duration = moment.duration(absoluteMs);
        const totalMinutes = Math.max(Math.floor(duration.asMinutes()), 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const compactDuration = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

        return ms < 0 ? `${overdueLabel} ${compactDuration}` : `${compactDuration} left`;
    }

    decoratePriorityDetails(serviceTicket) {
        const branchTimezone = serviceTicket.branchTimezone || (this.branchInfo && this.branchInfo.timezone) || moment.tz.guess();
        const requestedTimeframe = serviceTicket.requestedTimeframe || null;
        const referenceTime = this.getPriorityReferenceTime(serviceTicket);
        // Use branch timezone for comparison to show "Time Left" correctly (Now vs Deadline)
        const comparisonTime = moment().tz(branchTimezone);

        let effectiveRequestedTimeframe = requestedTimeframe;
        let priorityRemaining = null;
        let isOverdue = false;

        if (requestedTimeframe === 'SCHEDULED' && serviceTicket.targetTime) {
            // Treat as Branch Local
            const targetMoment = moment.tz(serviceTicket.targetTime, branchTimezone);
            const remainingMs = targetMoment.diff(comparisonTime);
            isOverdue = remainingMs <= 0;
            priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(remainingMs);
            
            // Already in branch timezone
            serviceTicket.targetTimeDisplay = targetMoment.format('MM/DD/YYYY | HH:mm:ss');
        }
        else {
            const priorityHours = this.getPriorityDurationHours(requestedTimeframe);

            if (priorityHours && referenceTime) {
                // Treat as Branch Local
                const deadlineMoment = moment.tz(referenceTime, branchTimezone).add(priorityHours, 'hours');
                const remainingMs = deadlineMoment.diff(comparisonTime);
                isOverdue = remainingMs <= 0;

                priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(remainingMs);
                
                // Already in branch timezone
                serviceTicket.targetTimeDisplay = deadlineMoment.format('MM/DD/YYYY | HH:mm:ss');
                serviceTicket.targetTime = deadlineMoment.toISOString();
                
            }
            else if (requestedTimeframe === 'ASAP') {
                if (referenceTime) {
                    const asapMoment = moment.tz(referenceTime, branchTimezone);
                    const remainingMs = asapMoment.diff(comparisonTime);
                    priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(remainingMs);
                    
                    serviceTicket.targetTimeDisplay = asapMoment.format('MM/DD/YYYY | HH:mm:ss');
                    serviceTicket.targetTime = asapMoment.toISOString();
                } else {
                    priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : 'Immediate';
                }
            }
        }

        if (isOverdue && ['24HR', '48HR', '72HR', 'SCHEDULED'].includes(requestedTimeframe)) {
            effectiveRequestedTimeframe = 'ASAP';
        }

        serviceTicket.displayRequestedTimeframe = effectiveRequestedTimeframe;
        serviceTicket.priorityRemaining = priorityRemaining;
        serviceTicket.priorityEscalated = requestedTimeframe !== 'ASAP' && effectiveRequestedTimeframe === 'ASAP';
        serviceTicket.isPriorityAlert = effectiveRequestedTimeframe === 'ASAP' || requestedTimeframe === '24HR';
    }

    decorateServiceTicket(serviceTicket) {
        if (serviceTicket.completed) {
            let timeDiff = moment(serviceTicket.completedAt).diff(serviceTicket.createdAt);
            let duration = moment.duration(timeDiff);
            let timePending = Math.floor(duration.asHours());
            serviceTicket.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
        }

        if (serviceTicket.cancelled) {
            let timeDiff = moment(serviceTicket.cancelledAt).diff(serviceTicket.createdAt);
            let duration = moment.duration(timeDiff);
            let timePending = Math.floor(duration.asHours());
            serviceTicket.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
        }

        this.decoratePriorityDetails(serviceTicket);
    }

    calculateThresholds() {
        this.serviceOrderThresolds = {};
        this.indexMap = {};

        this.buckets.forEach((b) => {
            if (b.bucket !== 'COMPLETE' && b.bucket !== 'CANCELLED') {
                this.serviceOrderThresolds[b.bucket] = {
                    totalRedThreshold: 0, totalOrangeThreshold: 0, totalYellowThreshold: 0, redThresholdIds: [],
                    orangeThresholdIds: [], yellowThresholdIds: []
                };
            }

            if (this.model.serviceOrderData[b.bucket].items.length && b.bucket !== 'COMPLETE' && b.bucket !== 'CANCELLED') {
                this.model.serviceOrderData[b.bucket].items.forEach((serviceTickets) => {
                    if (serviceTickets.thresholds && serviceTickets.thresholds.length) {
                        serviceTickets.thresholds.forEach((threshold) => {
                            if (threshold.redThreshold) {
                                if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.redThreshold)) && this.calculateHours(serviceTickets.createdAt) > this.getTime('06:00:00')) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.redThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('04:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.redThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('02:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('04:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                                        this.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId)
                                        this.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                    }
                                }
                            }
                            if (threshold.orangeThreshold) {
                                if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.orangeThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.orangeThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('04:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                                        this.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId)
                                        this.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.orangeThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('02:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('04:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                    }
                                }
                            }
                            if (threshold.yellowThreshold) {
                                if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.yellowThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                                        this.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId)
                                        this.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.yellowThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('04:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.yellowThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('02:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('04:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                                        this.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId)
                                        this.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                    }
                                }
                            }
                            if (threshold.otherThreshold) {
                                if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.otherThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.otherThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('04:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('06:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                    }
                                }
                                else if ((this.calculateHours(serviceTickets.createdAt) > this.getTime(threshold.otherThreshold)) && (this.calculateHours(serviceTickets.createdAt) > this.getTime('02:00:00') && this.calculateHours(serviceTickets.createdAt) < this.getTime('04:00:00'))) {
                                    if (!this.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                        this.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                        this.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                        this.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                    }
                                }
                            }
                        })
                    }
                })
            }
        })
    }

    getLastUpdatedTime() {
        this.lastUpdatedTime = moment().format('DD/MM/YYYY | hh:mm:ss A');
    }

    setDefaultBranch() {
        this.userBranchList.filter((branch) => {
            if (branch.Value == this.model.currentBranch) branch.ticked = true;
        })
    }

    formatAddress(data) {
        let locationAddress = '';
        if (data.address) {
            locationAddress = locationAddress.concat(data.address, ', ');
        }
        if (data.city) {
            locationAddress = locationAddress.concat(data.city, ', ');
        }
        if (data.state) {
            locationAddress = locationAddress.concat(data.state, ', ');
        }
        if (data.zip) {
            locationAddress = locationAddress.concat(data.zip);
        }
        return locationAddress;
    }

    showCreateModal() {
        let branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(branch => branch.Value) : [];
        this.Modal.createServiceTicket({ branch: branchIds, customerId: this.customerId }, ({ modal, data, assignData }) => {
            this.ServiceOrderService.create(data).then((res) => {
                const hasAssignment = assignData && (assignData.routeId || assignData.userId || assignData.externalProcessorCode);

                if (hasAssignment && res.data.encounterId) {
                    const encounterId = res.data.encounterId;
                    const branchId = data.branchId || this.User.getUser().branchId;
                    const vaultDate = this.formatVaultDate(this.model.branchVaultDate);

                    if (assignData.externalProcessorCode) {
                        return this.ServiceOrderService.transferUnassignedToExternal(encounterId, assignData.externalProcessorCode, branchId, this.model.loggedInUser)
                            .then(() => {
                                modal.close();
                                this.showCreateSuccessModal(res.data.message);
                            });
                    } else {
                        const route = assignData.currentStats === 'route' ? assignData.routeId : null;
                        const user = assignData.currentStats === 'user' ? assignData.userId.toString() : null;

                        return this.ServiceOrderService.assignToRouteOrUser(res.data.serviceOrderId, encounterId, user, route, null, branchId, vaultDate, null)
                            .then(() => {
                                modal.close();
                                this.showCreateSuccessModal(res.data.message);
                            });
                    }
                } else {
                    modal.close();
                    this.showCreateSuccessModal(res.data.message);
                }
            })
                .catch((err) => {
                    this.Modal.errorModal(err.data.message);
                })
                .finally(() => {
                    data.$scope.formSubmited = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    showCreateSuccessModal(message) {
        this.Modal.confirm({
            header: this.$translate.instant('successModal.title'),
            message: message,
            callback: (({ modal }) => {
                this.$onInit();
                modal.close();
            }),
            negative: (({ modal }) => {
                this.$onInit();
                modal.close();
            }),
            type: 'success',
            buttons: ['common.ok']
        })
    }

    // Update external service order status
    externalServiceOrderStatusUpdateModal(serviceOrder) {
        if (this.statusUpdate[serviceOrder.encounterId] && this.statusUpdate[serviceOrder.encounterId].process) return;
        this.statusUpdate[serviceOrder.encounterId] = { process: true };

        this.UsersService.checkSupervisor(this.model.loggedInUser)
            .then((userInfo) => {
                this.Modal.serviceOrderStatusUpdate(serviceOrder, !userInfo.supervisor, this.customerId, this.currentLoggedInUserInfo, ({ modal, note, status, supervisorId }) => {
                    let supId = userInfo.supervisor ? userInfo.id : supervisorId;
                    if (status === 'COMPLETE') {
                        return this.externalServiceOrderActionsModal(serviceOrder, note, supId).then(() => {
                            modal.close();
                            this.statusUpdate[serviceOrder.encounterId].process = false;
                        });
                    }
                    else {
                        return this.updateExternalServiceOrderStatus(serviceOrder, status, note, modal);
                    }
                }, ({ modal }) => {
                    if (modal) modal.close();
                    this.statusUpdate[serviceOrder.encounterId].process = false;
                })
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    updateExternalServiceOrderStatus(serviceOrder, status, note, modal) {
        return this.ServiceOrderService.updateExternalServiceOrderStatus(status, serviceOrder.encounterId, note, serviceOrder.branchId, serviceOrder.serviceOrderId, serviceOrder.externalProcessorId)
            .then(() => {
                this.loadData(); // refresh data after status update
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        this.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    }
                    else {
                        this.Modal.errorModal(err.data.message);
                    }
                }
            })
            .finally(() => {
                if (modal) modal.close();
                this.statusUpdate[serviceOrder.encounterId].process = false;
            })
    }

    externalServiceOrderActionsModal(serviceOrder, serviceOrderStatusNote, userId) {
        const defer = this.$q.defer();

        this.Modal.serviceOrderActions(serviceOrder, ({ modal, actionCodeData, $scope, completedByUserId, completedDate, completedTime }) => {
            const completedDateTime = completedDate.concat(' ', completedTime);
            const completedAt = moment(completedDateTime).utc().format();
            this.ServiceOrderService.markExternalServiceOrderCompleted(actionCodeData, serviceOrder.branchId, serviceOrder.routeId, serviceOrder.serviceOrderId,
                serviceOrder.encounterId, serviceOrderStatusNote, completedByUserId, completedAt, serviceOrder.externalProcessorId)
                .then(() => {
                    this.loadData(); // refresh data after status update
                    modal.close();
                    defer.resolve();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SOA_TOO_FEW_RESPONSES') {
                            $scope.model.errorMessage = this.$translate.instant('serviceTickets.too_few_responses');
                        }
                        else {
                            $scope.model.errorMessage = err.data.message;
                        }
                    }
                })
                .finally(() => {
                    $scope.model.isUpdate = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
        return defer.promise;
    }

    serviceTicketResolveImage(pictures, encounterId, index) {
        const obj = {
            pictures, encounterId
        }
        document.getElementById(`service-ticket-resolve-image-${index}`).blur();
        this.Modal.serviceTicketResolveImage(obj, ({ modal }) => {
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    viewServiceTicketImages(orders, event) {
        if (event && event.currentTarget) {
            event.currentTarget.blur();
        }
        orders.loadingImages = true;
        this.ServiceOrderService.getServiceOrderImages(orders.serviceOrderId)
            .then(res => {
                const files = (res.images || []).map(imageObj => ({
                    fileName: imageObj.name,
                    imageUrl: '/api/' + imageObj.url
                }));
                this.Modal.previewTicketPictures(files, null, null, null, false);
            })
            .catch(err => {
                console.error('Error fetching service order images:', err);
            })
            .finally(() => {
                orders.loadingImages = false;
            });
    }

    resendExternalServiceTickets(data) {
        this.externalProcessorObj[data.serviceOrderId] = { process: false };

        this.Modal.confirm({
            header: this.$translate.instant('serviceTickets.resend_external_service_request'),
            message: this.$translate.instant('serviceTickets.resend_external_service_request_message'),
            callback: ({
                modal,
                $scope
            }) => {
                this.externalProcessorObj[data.serviceOrderId].process = true;
                this.ServiceOrderService.resendExternalServiceTickets(data.externalProcessorId, data.serviceOrderId, this.model.loggedInUser, data.branchId)
                    .then(() => {
                        this.loadData();
                    })
                    .catch((err) => {
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        modal.close();
                        this.externalProcessorObj[data.serviceOrderId].process = false;
                    })
            },
            negative: ({
                modal,
            }) => {
                modal.close();
            },
            type: 'success'
        })
    }

    sortTime(bucket, column) {
        this.model.serviceOrderData[bucket].items = this.model.serviceOrderData[bucket].items.sort((a, b) => {
   
            const timeToSeconds = (time) => {
                if (!time) return NaN;
                const [hours, minutes, seconds] = time.split(':').map(Number);
                return hours * 3600 + minutes * 60 + seconds;
            };

            const timeA = timeToSeconds(a[column]);
            const timeB = timeToSeconds(b[column]);

            if (isNaN(timeA) && isNaN(timeB)) return 0;
            if (isNaN(timeA)) return 1;
            if (isNaN(timeB)) return -1;
            return this.sortOrderData[bucket][this.reverseSort] ? timeB - timeA : timeA - timeB;
        });
    }

    isTimeFormat(str) {
        const timeRegex = /^([01]?\d|2[0-3]):[0-5]?\d:[0-5]?\d$/;
        return timeRegex.test(str);
    }

    containsTimeKeyword(str) {
        const keywordRegex = /time/i;
        return keywordRegex.test(str);
    }

}

export default ServiceTicketsController;



// WEBPACK FOOTER //
// ./client/app/components/service_tickets/service_tickets.controller.js